package com.xtream.data_kmp.db.repo

import androidx.paging.Pager
import androidx.paging.PagingConfig
import androidx.paging.PagingData
import androidx.paging.PagingSource
import androidx.room3.Transaction
import com.xtream.data_kmp.AllConst
import com.xtream.data_kmp.AllConst.PAGING_PAGE_SIZE
import com.xtream.data_kmp.FavoriteSeriesStreamEntity
import com.xtream.data_kmp.db.AppRoomDB
import com.xtream.data_kmp.db.dao.BaseRoomStreamsInterface
import com.xtream.data_kmp.db.dao.RoomBaseInterface
import com.xtream.data_kmp.db.dao.SeriesSortBy
import com.xtream.data_kmp.db.tables.SeriesCategoryWithVisibleStatus
import com.xtream.data_kmp.db.tables.StreamType
import com.xtream.data_kmp.db.tables.toHiddenCategoryEntity
import com.xtream.data_kmp.dto.SeriesCategory
import com.xtream.data_kmp.dto.SeriesStream
import com.xtream.data_kmp.dto.TrendingTvShow
import kotlinx.coroutines.flow.Flow


class SeriesStreamsRepository (
    val db: AppRoomDB,
): LocalStreamsRepository<SeriesStream, FavoriteSeriesStreamEntity, SeriesCategory>(
    db.seriesDao() as BaseRoomStreamsInterface<SeriesStream>,
    db.seriesFavoritesDao() as RoomBaseInterface<FavoriteSeriesStreamEntity>,
    db.seriesCategoriesDao() as RoomBaseInterface<SeriesCategory>
){

    fun getStreamsFlow(categoryId:Int?=null, nameQuery:String?=null, limit: Int?=-1) : Flow<List<Any>?> {

        return when (categoryId) {
            AllConst.FAV_CATEGORIES_ID.toInt() -> getFavoritesAsFlow(limit)
            AllConst.WATCHED_CATEGORIES_ID.toInt() ->db.seriesDao().getWatchedStreamsAsIntermediateFlow()// getWatchedStreamsFlow(limit)
            else -> getStreamsAsFlow(categoryId = categoryId,limit=limit)
        }
    }


    fun  getPagedCategoriesWithStreams()= db.seriesCategoriesDao().getPagingCategoriesWithSize()

    suspend fun all(categoryId:Int?=AllConst.ALL_CATEGORIES_ID.toInt(), nameQuery:String?="",limit: Int?=15, offset: Int?=0): List<Any> {
        return when (categoryId) {
            AllConst.FAV_CATEGORIES_ID.toInt() -> db.seriesDao().getFavoriteStreams(limit)
            AllConst.WATCHED_CATEGORIES_ID.toInt() -> db.seriesDao()
                .getWatchedStreamsAsIntermediate(limit)

            else -> db.seriesDao()
                .all(categoryId = categoryId, nameQuery = nameQuery, limit = limit, offset = offset)
        }
    }
    suspend fun getTvShowByStreamId(id: Int?): SeriesStream? = db.seriesDao().getStreamById(id)
    fun getRecommendationsList(categoryId:Int?,limit: Int,
                               excludeIds:List<Int?>?=null,

                               ): Flow<List<SeriesStream>> = db.seriesDao().getRecommendationsList(categoryId,limit,excludeIds)





    @Transaction
    suspend fun refreshTrending(newList: List<TrendingTvShow>?){
        db.seriesDao().deleteTrending()
        if (newList == null) return
        db.seriesDao().insertTrending(newList)

    }

    fun getTrendingAsFlow() = db.seriesDao().trendingAsFlow()
    fun getStreamsAsPagingSource(
        categoryIds: List<Int>?,
        nameQuery: String?,
        sortBy: SeriesSortBy,
    ): PagingSource<Int, SeriesStream> = db.seriesDao().allAsPagingSource(categoryIds, nameQuery, sortBy)

    fun getPagedSeriesStreamsFlow(
        categoryIds: List<Int>?,
        keyWord: String?,
        sortBy: SeriesSortBy,
        yearRange: IntRange? = null,

        ):  Flow<PagingData<SeriesStream>> = Pager<Int, SeriesStream>(
        config = PagingConfig(
            pageSize = PAGING_PAGE_SIZE,
            enablePlaceholders = false,
        ),
        pagingSourceFactory = {
            when {
                categoryIds.isNullOrEmpty() -> db.seriesDao().allAsPagingSource(null, keyWord, sortBy, yearRange)
                categoryIds.firstOrNull() == AllConst.FAV_CATEGORIES_ID.toInt() -> getFavoritesPagingSource()
                else -> db.seriesDao().allAsPagingSource(categoryIds, keyWord, sortBy, yearRange)

            }
        }
    ).flow

    fun getCategoriesWithVisibleStatus():
            Flow<List<SeriesCategoryWithVisibleStatus>> {

        return db.seriesCategoriesDao().getCategoriesWithVisibleStatus()

    }

   suspend fun toggleCategoryVisibility(category: SeriesCategory) {
        if (category.categoryId==null) return
        val hiddenCategory= category.toHiddenCategoryEntity(StreamType.SERIES)
        with(db.hiddenCategoryDao()) {
            val isHidden =  isHidden(category.categoryId, StreamType.SERIES)
            if (isHidden)
                unhideCategory(hiddenCategory)
            else
                hideCategory(hiddenCategory)
        }
    }

}